/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    isPersonal: currentUser?.isPersonal,//个人用户
    isEnterprise:currentUser?.isEnterprise,//企业用户
  };
}
